import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { usePWAInstall } from '../../hooks/usePWAInstall';
import { requestInstallPrompt } from '../../components/pwa/PWAInstallPrompt';
import AppLayout from '../../components/layout/AppLayout';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Icon from '../../components/ui/Icon';

function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const { installable, installed } = usePWAInstall();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState('');
  const [infoMessage, setInfoMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormError('');
    setInfoMessage('');

    if (!email.trim() || !password) {
      setFormError('Ingresa tu correo y contraseña.');
      return;
    }

    setSubmitting(true);
    const result = await signIn({ email: email.trim(), password });
    setSubmitting(false);

    if (!result.ok) {
      setFormError(result.message);
      return;
    }

    navigate('/');
  };

  return (
    <AppLayout>
      <div className="flex flex-col">
        <header className="pt-8 text-center">
          <img
            src="/logo-family-growers.png"
            alt="Family Growers"
            className="mx-auto w-full max-w-[220px] sm:max-w-[260px] h-auto"
          />
          <p className="mt-2 text-center text-sm sm:text-base font-medium text-slate-500">
            App de Campo
          </p>
        </header>

        <div className="mt-5 sm:mt-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <h2 className="mb-6 text-xl font-semibold text-gray-900">Inicio de sesión</h2>

          <form className="flex flex-col gap-4" onSubmit={handleSubmit} noValidate>
            <Input
              id="email"
              label="Correo electrónico"
              type="email"
              placeholder="nombre@correo.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
            />
            <Input
              id="password"
              label="Contraseña"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
            />

            {formError && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{formError}</p>}
            {infoMessage && <p className="rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700">{infoMessage}</p>}

            <Button type="submit" className="mt-2" disabled={submitting}>
              {submitting ? 'Ingresando...' : 'Iniciar sesión'}
            </Button>

            <button
              type="button"
              className="text-center text-sm text-gray-400 hover:text-gray-600"
              onClick={() =>
                setInfoMessage(
                  'La recuperación de contraseña estará disponible próximamente. Por ahora, comunícate con el administrador.'
                )
              }
            >
              ¿Olvidaste tu contraseña?
            </button>
          </form>

          <div className="mt-6 flex flex-col items-center gap-3 border-t border-gray-100 pt-6 text-center">
            <p className="text-sm text-gray-500">¿No tienes una cuenta?</p>
            <Button type="button" variant="secondary" onClick={() => navigate('/registro')}>
              Crear cuenta
            </Button>
          </div>
        </div>

        {installable && !installed && (
          <button
            type="button"
            onClick={requestInstallPrompt}
            className="mt-8 flex min-h-[44px] items-center justify-center gap-2 rounded-xl px-4 text-sm font-medium text-green-700 transition-colors hover:bg-green-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
          >
            <Icon name="install" className="h-5 w-5" />
            Instalar Family Growers
          </button>
        )}
      </div>
    </AppLayout>
  );
}

export default LoginPage;
